const { Auth, Storage } = require("aws-amplify");

class s3Util {
  constructor(){
    this.tenant = ""
    
  }
  /**
   * ログイン情報からグループID取得
   * @returns グループID
   */
  async getGroup() {
    const user = await Auth.currentAuthenticatedUser()
    return user.signInUserSession.accessToken.payload["cognito:groups"]
  }

  async makePrefix() {
    try {
      // グループ名を取得
      const result = await this.getGroup()
      if (!result) {
        throw `グループID無し`
      }
      this.tenant = result
      this.s3KeyPrefix = `tenant2/${this.tenant}/`
      
    } catch (e) {
      console.log(`${JSON.stringify(e)}`)
      throw e
    }
  }

  async getTenantFile(key) {
    await this.makePrefix()
    const config = {level: "public", customPrefix: {public: this.s3KeyPrefix}}
    return await this.getUrl(key, config)

  }

  async putTenantFile(key) {

  }

  async listTenantFiles(key) {

  }

  async removeTenantFile(key) {

  }

  async get(key, config) {
    try {
      let imageUrl = await Storage.get(key, config)
      return imageUrl
    } catch (e) {
      this.debugText = `エラー:${JSON.stringify(e)}`
    }
  }
  
  async getUrl(key, isBinary = false, config = null) {
    // パブリック領域からバイナリダウンロードを行う場合は以下のconfigを指定する
    //{level: "public", download: true}
    try {
      
      let cfg = config
      // configが未定義であればpublicから取得する
      if (!cfg) {
        cfg = { level: "public", download: isBinary }
      }
      // download指定が無ければ指定する
      if (!cfg.download) {
        cfg.download = isBinary
      }
      // level指定がなければpublicとする
      if (!cfg.level) {
        cfg.level = "public"
      }
      // Amplify.Storageクラスを使用してダウンロードする
      let data = await Storage.get(key, cfg)
      
      if (!data) {
        return
      }

      if (isBinary) {
        // imgタグに表示用のバイナリURLをレスポンスする
        if (!data.Body) {
          return 
        }
        return 'data:image/png;base64,' + data.Body.toString('base64')
      } else {
        return data
      }
      
    } catch (e) {
      console.log(e)
      return
    }
  }
}

module.exports = s3Util